import React from 'react';
import { Accordion } from '../ui/Accordion';
import { Button } from '../ui/Button';
export const FAQ = () => {
  const faqItems = [{
    title: 'Who runs the sales call?',
    content: <p data-id="element-271">
          A Senior PM (often your eventual Lead PM), not an SDR. You'll leave
          with a draft 2-week plan and a recommended tier.
        </p>
  }, {
    title: 'Can we interview your PMs first?',
    content: <p data-id="element-272">
          Default is a fast start: after your consult, we assign a Senior Lead
          PM within 48 hours. If you prefer, we'll arrange up to two 15-minute
          chemistry checks. You can swap PMs anytime in the first 14 days or
          receive a 75% refund.
        </p>
  }, {
    title: 'What exactly is Product Management as a Service?',
    content: <p data-id="element-273">
          ZERO TO TEN provides you with experienced product managers on a
          subscription basis. Instead of hiring a full-time PM, you get access
          to professional product management expertise for a fraction of the
          cost, working the hours you need.
        </p>
  }, {
    title: 'Do you build prototypes?',
    content: <p data-id="element-274">
          Yes. We use no-code and AI-assisted tools to build interactive
          prototypes quickly, so you can test ideas without waiting months. Our
          PMs are skilled in rapid experimentation techniques that get your
          ideas in front of users fast.
        </p>
  }, {
    title: 'What AI tools do you use?',
    content: <p data-id="element-275">
          We leverage generative AI, machine learning frameworks and
          market-analysis tools to drive research, ideation and product design.
          Our toolkit includes LLMs for content generation, computer vision for
          UI analysis, and predictive analytics for market research.
        </p>
  }, {
    title: 'How do you integrate with our AI initiatives?',
    content: <p data-id="element-276">
          We work with your data scientists and engineers to prioritize AI
          features and ensure alignment with your roadmap. Our PMs have
          experience translating technical AI capabilities into valuable product
          features and can bridge the gap between technical teams and business
          goals.
        </p>
  }, {
    title: 'How quickly can you start working with our team?',
    content: <p data-id="element-277">
          We can typically match you with a dedicated PM and begin work within
          one week of subscribing to a plan. Our onboarding process is
          streamlined to get you up and running as quickly as possible.
        </p>
  }, {
    title: 'Can we change plans as our needs evolve?',
    content: <p data-id="element-278">
          Absolutely! You can upgrade or downgrade your plan at any time. If
          your product needs more attention during a critical phase, you can
          temporarily upgrade, then scale back when appropriate.
        </p>
  }, {
    title: "What if we're not satisfied with our product manager?",
    content: <p data-id="element-279">
          We stand behind our service with a satisfaction guarantee. If you're
          not happy with your PM for any reason, we'll match you with a new one.
          If you decide PMaaS isn't right for you within the first two weeks,
          we'll refund 75% of your payment.
        </p>
  }, {
    title: 'How does communication work with our PM?',
    content: <p data-id="element-280">
          Your dedicated PM will integrate with your existing communication
          tools (Slack, Teams, etc.) and project management systems. They'll
          participate in regular check-ins based on your plan level and be
          available via email for questions between sessions.
        </p>
  }];
  const openCalendly = () => {
    window.open('https://calendly.com/zerototendigital/exploration-feature-design', '_blank');
  };
  return <section id="faq" className="py-20 bg-purple-50 relative overflow-hidden" data-id="element-281">
      {/* Background pattern elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-purple-100 rounded-full opacity-40 -ml-48 -mt-48" data-id="element-282"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-purple-100 rounded-full opacity-30 -mr-40 -mb-40" data-id="element-283"></div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-284">
        <div className="text-center mb-16" data-id="element-285">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-black" data-id="element-286">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-text-secondary max-w-2xl mx-auto" data-id="element-287">
            Everything you need to know about our Product Management as a
            Service.
          </p>
        </div>
        <div className="max-w-3xl mx-auto bg-white p-6 rounded-lg border border-gray-100 shadow-card" data-id="element-288">
          <Accordion items={faqItems} data-id="element-289" />
        </div>
        {/* Final CTA repeated at bottom of FAQ */}
        <div className="mt-16 text-center" data-id="element-290">
          <Button variant="primary" onClick={openCalendly} className="text-lg px-8 py-4" data-id="element-291">
            Speak with a Senior PM
          </Button>
        </div>
      </div>
    </section>;
};